import angular from 'angular';

import component from './questions-phone-preview.component';

const QuestionsPhonePreview = angular
    .module('control-room.app-settings.components.preferences-phone-preview.components.questions-phone-preview', [])
    .component('crQuestionsPhonePreview', component);

export default QuestionsPhonePreview;
